import React, { useEffect, useState } from "react";
import { API_URL } from "../config";
import { apiRequest } from "../apiRequest";
import AppLoader from "./AppLoader";

export default function SessionAccessGate({ children, onSignOut, onSession }) {
  const [state, setState] = useState("checking");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    let checking = false;
    let blocked = false;
    const deny = () => {
      blocked = true;
      if (active) setState("blocked");
    };
    const check = async () => {
      if (checking) return;
      checking = true;
      try {
        const { data } = await apiRequest(`${API_URL}/session-access`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` }
        }, { retries: 0, timeoutMs: 10000 });
        if (
          data?.allowed !== true ||
          typeof data?.user?.id !== "string" ||
          !data.user.id ||
          typeof data?.user?.role !== "string" ||
          !data.user.role
        ) {
          throw new Error("Session response could not be verified");
        }
        if (active && data?.user) onSession?.(data.user);
        if (active && !blocked) setState("allowed");
      } catch (error) {
        if (!active) return;
        if (error.data?.code === "MOBILE_ACCESS_BLOCKED") deny();
        else if (!blocked) setState(error.status === 401 ? "expired" : "error");
      } finally {
        checking = false;
      }
    };
    const handlePageShow = () => {
      if (active) setState("checking");
      check();
    };
    window.addEventListener("mobile-access-blocked", deny);
    window.addEventListener("focus", check);
    window.addEventListener("pageshow", handlePageShow);
    check();
    const timer = setInterval(check, 60000);
    return () => {
      active = false;
      clearInterval(timer);
      window.removeEventListener("mobile-access-blocked", deny);
      window.removeEventListener("focus", check);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [attempt, onSession]);

  if (state === "allowed") return children;
  if (state === "checking") return <AppLoader />;
  return (
    <main className="session-access-page">
      <section className="session-access-message" aria-live="polite">
        <h1>{state === "blocked" ? "Please use your office computer" :
          state === "expired" ? "Please sign in again" : "Unable to verify access"}</h1>
        {state === "blocked" && <p>Mobile access is not available for your agent role.</p>}
        {state === "error" && <button onClick={() => { setState("checking"); setAttempt((n) => n + 1); }}>Retry</button>}
        {state !== "checking" && <button className="logout-btn" onClick={onSignOut}>Back to login</button>}
      </section>
    </main>
  );
}
